import { faSearch, faTimesCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import styled from "styled-components"
import { useDebouncedCallback } from "use-debounce"
import Spinner from "./Spinner"

const Wrapper = styled.div`
  ${({ theme }) => `
    white-space: nowrap;
    position: relative;
    display: flex;
    align-items: center;
    flex-grow: 1;

    .svg-inline--fa {
      position: absolute;
      top: 50%;
      left: 12px;
      transform: translate3d(0, -50%, 0);
      pointer-events: none;
    }

    .challenge__search__clear {
      right: 12px;
      left: auto;
      cursor: pointer;
      pointer-events: auto;
    }

    input {
      margin-right: 0.75rem;
      width: 100% !important;
      padding-left: 36px;
    }

    .spinner-border {
      position: absolute;
      left: calc(100% - 20px);
    }

    ${theme.breakpoints.up('sm')} {
        .spinner-border {
            left: calc(100% - 30px);
        }
    }

    .form-control--flat {
      height: 44px;
      border-radius: ${theme.rounded.sm}
    }

    .form-control--flat-md {
      border-radius: ${theme.rounded.md}
    }
  `}
`;

const Search = ({ className, isLoading, onChange, value }) => {
  const { t } = useTranslation();
  const [input, setInput] = useState("");

  const handler = useDebouncedCallback((value) => {
    if (value?.length < 3 && value?.length !== 0) {
      return
    }
    return onChange(value)
  }, 250);

  const setter = ({ target }) => {
    setInput(target.value);
    handler(target.value);
  };

  useEffect(() => setInput(value), [value]);

  return (
    <Wrapper>
      <FontAwesomeIcon icon={faSearch} />
      <input
        className={`form-control ${className}`}
        type="text"
        placeholder={t('Search')}
        aria-label="Search"
        onChange={setter}
        value={input}
        data-testid="challenge__search__input"
      />
      {isLoading && <Spinner size="0.875rem" />}
      {
        !isLoading && !!input
          ? (
            <FontAwesomeIcon 
              icon={faTimesCircle} 
              className="challenge__search__clear" 
              onClick={() => {
                setter({
                  target: {
                    value: ''
                  }
                })
              }}
            />
          )
          : null
      }
    </Wrapper>
  );
};

export default Search;
